import styled from 'styled-components';

export const Container = styled.div``;

export const Label = styled.label`
	text-transform: uppercase;
	font-weight: bold;
	font-size: 1rem;
`;

export const Wrapper = styled.div`
	position: relative;
	
	select {
		width: 100%;
		appearance: none;
		font-weight: bold;
		border: 2px solid #e8dcc2;
		height: 50px;
		line-height: 46px;
		text-transform: uppercase;
		padding-left: 10px;
		font-size: 0.8rem;
		cursor: pointer;
	}
`;

export const Chevron = styled.div`
	pointer-events: none;
	position: absolute;
	width: 16px;
	height: 16px;
	top: 0;
	bottom: 0;
	margin: auto 0;
	right: 8px;
`;
